export const patientCareTasksMockData = [
  {
    taskId: 'TASK-1001',
    patientId: 'PT-1001',
    patientName: 'John Smith',
    taskDescription: 'Administer antibiotics',
    assignedToStaffId: 'STAFF-123',
    assignedToStaffName: 'Nurse Sarah Collins',
    taskStatus: 'Pending',
    dueDate: '2023-12-04T14:00:00',
    priority: 'High',
    taskNotes: 'IV administration, 500mg dose',
    createdAt: '2023-12-04T08:30:00',
    createdBy: 'Dr. Sarah Johnson',
    category: 'Medication',
    department: 'General Surgery',
    roomNumber: 'A-201'
  },
  {
    taskId: 'TASK-1002',
    patientId: 'PT-1023',
    patientName: 'Emma Wilson',
    taskDescription: 'Check vitals and oxygen saturation',
    assignedToStaffId: 'STAFF-145',
    assignedToStaffName: 'Nurse Michael Chen',
    taskStatus: 'Completed',
    dueDate: '2023-12-04T10:00:00',
    completedAt: '2023-12-04T09:45:00',
    priority: 'Medium',
    taskNotes: 'Record BP, temperature, and pulse oximetry',
    createdAt: '2023-12-04T06:00:00',
    createdBy: 'Dr. Robert Chen',
    category: 'Vitals Check',
    department: 'Pulmonology',
    roomNumber: 'B-105'
  },
  {
    taskId: 'TASK-1003',
    patientId: 'PT-1045',
    patientName: 'Michael Brown',
    taskDescription: 'Blood glucose monitoring',
    assignedToStaffId: 'STAFF-167',
    assignedToStaffName: 'Nurse Amanda Rodriguez',
    taskStatus: 'Pending',
    dueDate: '2023-12-04T12:00:00',
    priority: 'High',
    taskNotes: 'Check before lunch, adjust insulin as per sliding scale',
    createdAt: '2023-12-04T08:15:00',
    createdBy: 'Dr. Emily Taylor',
    category: 'Diagnostic',
    department: 'Endocrinology',
    roomNumber: 'C-310'
  },
  {
    taskId: 'TASK-1004',
    patientId: 'PT-1067',
    patientName: 'Jessica Lee',
    taskDescription: 'Physical therapy session',
    assignedToStaffId: 'STAFF-189',
    assignedToStaffName: 'PT Daniel Morris',
    taskStatus: 'Pending',
    dueDate: '2023-12-04T15:30:00',
    priority: 'Medium',
    taskNotes: 'Gentle range-of-motion exercises',
    createdAt: '2023-12-03T17:00:00',
    createdBy: 'Dr. James Wilson',
    category: 'Therapy',
    department: 'Orthopedics',
    roomNumber: 'D-112'
  },
  {
    taskId: 'TASK-1005',
    patientId: 'PT-1123',
    patientName: 'Sophia Martinez',
    taskDescription: 'IV fluid management',
    assignedToStaffId: 'STAFF-123',
    assignedToStaffName: 'Nurse Sarah Collins',
    taskStatus: 'Completed',
    dueDate: '2023-12-04T11:00:00',
    completedAt: '2023-12-04T10:50:00',
    priority: 'High',
    taskNotes: 'Replace IV bag, check flow rate',
    createdAt: '2023-12-04T07:30:00',
    createdBy: 'Dr. Thomas Baker',
    category: 'Fluid Management',
    department: 'Internal Medicine',
    roomNumber: 'B-202'
  },
  {
    taskId: 'TASK-1006',
    patientId: 'PT-1178',
    patientName: 'Olivia Johnson',
    taskDescription: 'Administer pain medication',
    assignedToStaffId: 'STAFF-145',
    assignedToStaffName: 'Nurse Michael Chen',
    taskStatus: 'Pending',
    dueDate: '2023-12-04T13:00:00',
    priority: 'Medium',
    taskNotes: 'As per patient request, check pain level first',
    createdAt: '2023-12-04T09:00:00',
    createdBy: 'Dr. Michael Williams',
    category: 'Medication',
    department: 'Neurology',
    roomNumber: 'D-305'
  },
  {
    taskId: 'TASK-1007',
    patientId: 'PT-1201',
    patientName: 'William Taylor',
    taskDescription: 'Wound dressing change',
    assignedToStaffId: 'STAFF-167',
    assignedToStaffName: 'Nurse Amanda Rodriguez',
    taskStatus: 'Pending',
    dueDate: '2023-12-04T16:00:00',
    priority: 'High',
    taskNotes: 'Use sterile technique, check for signs of infection',
    createdAt: '2023-12-04T08:45:00',
    createdBy: 'Dr. Sarah Johnson',
    category: 'Wound Care',
    department: 'General Surgery',
    roomNumber: 'A-215'
  },
  {
    taskId: 'TASK-1008',
    patientId: 'PT-1305',
    patientName: 'Robert Johnson',
    taskDescription: 'Ventilator settings check',
    assignedToStaffId: 'STAFF-210',
    assignedToStaffName: 'Nurse David Chen',
    taskStatus: 'Completed',
    dueDate: '2023-12-04T08:00:00',
    completedAt: '2023-12-04T07:45:00',
    priority: 'Critical',
    taskNotes: 'Verify settings match prescribed parameters',
    createdAt: '2023-12-03T22:00:00',
    createdBy: 'Dr. Lisa Thompson',
    category: 'Respiratory',
    department: 'ICU',
    roomNumber: 'D-001'
  },
  {
    taskId: 'TASK-1009',
    patientId: 'PT-1367',
    patientName: 'Patricia White',
    taskDescription: 'Chemotherapy administration',
    assignedToStaffId: 'STAFF-245',
    assignedToStaffName: 'Nurse Jennifer Lopez',
    taskStatus: 'Pending',
    dueDate: '2023-12-04T13:30:00',
    priority: 'Critical',
    taskNotes: 'Follow protocol for specific drug regimen',
    createdAt: '2023-12-04T07:00:00',
    createdBy: 'Dr. Mark Robinson',
    category: 'Medication',
    department: 'Oncology',
    roomNumber: 'A-301'
  },
  {
    taskId: 'TASK-1010',
    patientId: 'PT-1001',
    patientName: 'John Smith',
    taskDescription: 'Post-operative assessment',
    assignedToStaffId: 'STAFF-189',
    assignedToStaffName: 'PT Daniel Morris',
    taskStatus: 'Pending',
    dueDate: '2023-12-04T17:00:00',
    priority: 'Medium',
    taskNotes: 'Evaluate mobility, pain levels, and wound site',
    createdAt: '2023-12-04T10:00:00',
    createdBy: 'Dr. Sarah Johnson',
    category: 'Assessment',
    department: 'General Surgery',
    roomNumber: 'A-201'
  }
]
